import { AxiosResponse } from 'axios';
import { scoreStatusMap } from '../components/_clients/ScoreStatusBadge';
import { api } from './axios';
import { getFailureReasonText } from './failureReasonMap';

const clientsEndpoints = {
  clients: '/users',
};

export async function getCsvDataClients({
  _end,
  _order,
  _sort,
  _start,
  userInfo,
  period,
}: {
  _end: number;
  _order: string;
  _sort: string;
  _start: number;
  userInfo?: string;
  period?: string;
}) {
  try {
    const queryStrings: any = {
      _end,
      _order,
      _sort,
      _start,
      getFaceUsageIntentions: true,
      q: '',
      where: {
        userInfo: userInfo || '',
      },
    };

    if (period && period !== 'ALL') {
      queryStrings.period = period;
    }

    const response: AxiosResponse<any> = await api.get(clientsEndpoints.clients, {
      params: queryStrings,
    });

    const clients = Array.isArray(response?.data) ? response.data : response?.data ? [response.data] : [];

    const csvData = clients.map((client) => {
      const [faceUsageIntentions] = client?.faceUsageIntentions || [];
      const matchedUser = faceUsageIntentions?.matchedUser;
      const scoreStatus = matchedUser?.scoreStatus;

      return {
        Nome: `${client.firstName || ''} ${client.lastName || ''}`,
        CPF: client.cpf || '',
        Email: matchedUser?.email || '',
        'Data de criação': client.createdAt ? new Date(client.createdAt).toLocaleString('pt-BR') : '',
        'Status do Cliente': matchedUser?.scoreStatus
          ? scoreStatusMap[matchedUser?.scoreStatus].text
          : scoreStatusMap.default.text,
        Motivo: getFailureReasonText(faceUsageIntentions?.failureReason, scoreStatus) || '-',
        Estabelecimento: client.place || '',
      };
    });

    return csvData;
  } catch (error) {
    throw new Error(error.message);
  }
}
